import template from './template.html';

export default {
  url: '/compliance?license&category',
  stateName: 'My Compliance',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: false,
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/compliance')
  },
  params: {
    license: {
      value: 'null',
      squash: true
    },
    category: {
      value: 'null',
      squash: true
    }
  },
  views: {
    'a@app': {
      template
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/controllers/users/compliance/index.js